import React from 'react';

export const FilledEyeSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="23"
    height="16"
    viewBox="0 0 23 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8281 0.09375C6.82812 0.09375 2.55469 3.20312 0.828125 7.59375C2.55469 11.9844 6.82812 15.0938 11.8281 15.0938C16.8281 15.0938 21.1016 11.9844 22.8281 7.59375C21.1016 3.20312 16.8281 0.09375 11.8281 0.09375ZM17.4297 7.59375C17.4297 10.6914 14.9219 13.1992 11.8281 13.1992C8.72656 13.1992 6.21875 10.6914 6.21875 7.59375C6.21875 4.49609 8.72656 1.98828 11.8281 1.98828C14.9219 1.98828 17.4297 4.49609 17.4297 7.59375ZM13.7344 9.11719C14.0703 8.69922 14.2734 8.17188 14.2734 7.59375C14.2734 6.24219 13.1797 5.14844 11.8281 5.14844C10.9375 5.14844 10.1641 5.62109 9.73438 6.33203C9.50781 6.69922 9.38281 7.13281 9.38281 7.59375C9.38281 8.94531 10.4766 10.0391 11.8281 10.0391C12.6016 10.0391 13.2891 9.67969 13.7344 9.11719Z"
      fill="currentColor"
    />
  </svg>
);

export default FilledEyeSvg;
